module.exports = __webpack_public_path__ + "assets/icon-arrow-down.371286cc.svg";